import type TrailDetails from '@alltrails/core/types/TrailDetails';
import type Trail from '@alltrails/types/Trail';

// This replicates TrailRecord#location_label in the monolith
// https://github.com/alltrails/alltrails/blob/953f5558688356f2f549c158d324c3fd1fbeee35/app/components/search/records/trail_record.rb#L150-L162

const getTrailLocationAndAreaName = (trail: Trail | TrailDetails) => {
  if (trail.location?.country === 'US' || trail.location?.country === 'CA') {
    if (trail.area) {
      return `${trail.area.name}, ${trail.location.regionName}`;
    } else {
      return `${trail.location.city}, ${trail.location.regionName}`;
    }
  }
  if (trail.area) {
    return `${trail.area.name}, ${trail.location?.country_name}`;
  }

  return `${trail.location?.regionName || trail.location?.city}, ${trail.location?.country_name}`;
};

export default getTrailLocationAndAreaName;
